module.exports = __webpack_public_path__ + "2ee3ab3b6ba4c99f921a55dd4e32d500.png";